"use strict";
var Observable_1 = require("../../Observable");
var windowCount_1 = require("../../operator/windowCount");
Observable_1.Observable.prototype.windowCount = windowCount_1.windowCount;
//# sourceMappingURL=windowCount.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/windowCount.js
 ** module id = 435
 ** module chunks = 1
 **/